var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("nav", { attrs: { "aria-label": "..." } }, [
    _c(
      "ul",
      { staticClass: "pagination justify-content-center" },
      [
        _c(
          "li",
          { class: { "page-item": true, disabled: _vm.currentPage <= 1 } },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                attrs: { href: "", tabindex: "-1" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.prev($event)
                  }
                }
              },
              [_vm._v("Page précédente")]
            )
          ]
        ),
        _vm._v(" "),
        _vm._l(_vm.range, function(i) {
          return _c(
            "li",
            { class: { "page-item": true, active: _vm.currentPage === i } },
            [
              _vm.currentPage !== i
                ? [
                    _c(
                      "a",
                      {
                        staticClass: "page-link",
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            _vm.gotoPage(i)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(i) +
                            "\n                    "
                        ),
                        _vm.currentPage === i
                          ? _c("span", { staticClass: "sr-only" }, [
                              _vm._v(" (current)")
                            ])
                          : _vm._e()
                      ]
                    )
                  ]
                : [
                    _c("div", { staticClass: "page-link" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(i) +
                          "\n                    "
                      ),
                      _vm.currentPage === i
                        ? _c("span", { staticClass: "sr-only" }, [
                            _vm._v(" (current)")
                          ])
                        : _vm._e()
                    ])
                  ]
            ],
            2
          )
        }),
        _vm._v(" "),
        _c(
          "li",
          {
            class: {
              "page-item": true,
              disabled: _vm.currentPage >= _vm.maxPage
            }
          },
          [
            _c(
              "a",
              {
                staticClass: "page-link",
                attrs: { href: "" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.next($event)
                  }
                }
              },
              [_vm._v("Page suivante")]
            )
          ]
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4bcd62e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bcd62e4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/SiteBundle/Resources/assets/components/Pagination.vue
// module id = 525
// module chunks = 1